(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["incenzo-mobile-sticky-atc"] && !Shopify.designMode) return;
  try {
    (() => {
    const mobileQuery = window.matchMedia('(max-width: 749px)');
    let cleanupScroll = null;

    const getBar = () => document.querySelector('[data-incenzo-mobile-sticky-atc]');

    const getProductInfo = (bar) => bar?.closest('product-info') || document.querySelector('product-info');

    const getPrimaryButton = (bar) => {
      const productInfo = getProductInfo(bar);
      const formId = bar?.dataset.productFormId;
      if (formId) {
        const scopedButton = productInfo?.querySelector(`#${CSS.escape(formId)} button[name="add"]`);
        if (scopedButton) return scopedButton;
      }
      return productInfo?.querySelector('product-form button[name="add"]');
    };

    const syncBar = () => {
      const bar = getBar();
      const primaryButton = getPrimaryButton(bar);
      if (!bar || !primaryButton) {
        document.body.classList.remove('incenzo-mobile-sticky-atc-active');
        return;
      }

      const stickyButton = bar.querySelector('[data-incenzo-sticky-submit]');
      const stickyText = bar.querySelector('[data-incenzo-sticky-button-text]');
      const primaryText = primaryButton.textContent.trim();
      const isDisabled = primaryButton.disabled || primaryButton.getAttribute('aria-disabled') === 'true';

      if (stickyButton) stickyButton.disabled = isDisabled;
      if (stickyText && primaryText) stickyText.textContent = primaryText;
      bar.classList.toggle('is-disabled', isDisabled);

      const rect = primaryButton.getBoundingClientRect();
      const shouldShow = mobileQuery.matches && rect.bottom < 0;

      bar.hidden = !mobileQuery.matches;
      bar.classList.toggle('is-visible', shouldShow);
      document.body.classList.toggle('incenzo-mobile-sticky-atc-active', shouldShow);
    };

    const bindScroll = () => {
      cleanupScroll?.();
      const onScroll = () => window.requestAnimationFrame(syncBar);

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      mobileQuery.addEventListener('change', syncBar);

      cleanupScroll = () => {
        window.removeEventListener('scroll', onScroll);
        window.removeEventListener('resize', onScroll);
        mobileQuery.removeEventListener('change', syncBar);
      };

      syncBar();
    };

    document.addEventListener('click', (event) => {
      const stickyButton = event.target.closest('[data-incenzo-sticky-submit]');
      if (!stickyButton) return;

      const bar = stickyButton.closest('[data-incenzo-mobile-sticky-atc]');
      const primaryButton = getPrimaryButton(bar);
      if (!primaryButton || primaryButton.disabled) return;

      primaryButton.click();
    });

    document.addEventListener('product-info:loaded', bindScroll);
    document.addEventListener('variant:change', syncBar);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bindScroll, { once: true });
    } else {
      bindScroll();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
